export default __webpack_public_path__ + "static/media/hog@2x.fd83cba9.jpg";